<template>
  <div 
    class="sp-item ui-card bg-trans"
    v-if="!(cfg_view_staked && num_staked == 0)"
    >

    <div class="pt-4 pb-5 tac bg-card">
      <div>

        <span class="ui-icon size-40" style="position: relative;z-index: 1;">
          <img :src="(`/static/token_icons/${item.item_icon}?v2`) ">
        </span>

        <span v-if="item.item_icon_b" class="ui-icon size-40" style="margin-left: -10px;">
          <img :src="(`/static/token_icons/${item.item_icon_b}?v2`) ">
        </span>

        <span v-if="0" class="ui-icon-box-fire">
          <span class="fire-icon-a ui-icon size-30">
            <img :src="`/static/token_icons/${item.item_icon}?v2`">
          </span>
          <span class="fire-icon-b ui-icon size-30">
            <img :src="`/static/token_icons/${item.item_icon_b}?v2`">
          </span>
        </span>
      </div>

      <div 
        class="d-flex flex-column justify-content-center" 
        style="min-height: 120px;"
        >
        <div 
          class="i d-flex justify-content-center align-items-center"
          style="min-height: 50px;line-height:25px;"
          >

          <span>
            {{item.id}}
            {{lg('',{
              en: 'Pool',
              zh: '矿池',
            })}}
          </span>
        </div>

        <div 
          class="tac"
          style="min-height: 30px; line-height: 30px;"
          >
          {{item.multiple}}X
        </div>

        <div 
          v-if="item.second_title" 
          class="text-center b mt-2" 
          style="min-height: 30px; line-height: 30px;"
          >
          <span style="font-size: 1.1em; ">
            {{lg('',item.second_title)}}
          </span>
        </div>

      </div>

    </div>

    <div class="p-4 bg-white" style="margin-top: -20px;border-radius: 12px;">

      <div class="d-flex mb-3">
        <span class="b">
          {{lg('',{
            en: 'Lava Earned',
            zh: 'Lava已赚取',
          })}}:
        </span>
        <span class="b ml-auto"> 
          <!-- LAVA -->
          {{num_reward | tofixed2 | qfw}}
        </span>
      </div>

      <div class="mx-2 mb-3">
        <router-link 
          class="btn btn-lg btn-primary w-100"
          :to="{
            name: 'stake_item_pool',
            params: {
              id: item.id,
            },
          }"
          >
          {{lg('',{
            en: 'Open',
            zh: '打开',
          })}}
        </router-link>
      </div>

      <div class="d-flex small">
        <span class="t-gray">
          {{lg('',{
            en: 'APY',
            zh: '',
          })}}:
        </span>
        <span class="t-gray ml-auto"> 
          {{calc_apy | tofixed2 | bfh}}
        </span>
      </div>

      <div class="d-flex small">
        <span class="t-gray">
          {{lg('',{
            en: 'Your Stake',
            zh: '存储',
          })}}:
        </span>
        <span class="t-gray ml-auto"> 
          {{num_staked | tofixed2 | qfw}}
        </span>
      </div>

      <div class="d-flex small mb-3">
        <span class="t-gray">
          {{lg('',{
            en: 'TVL',
            zh: '总锁定',
          })}}:
        </span>
        <span class="t-gray ml-auto"> 
          {{num_staked_total | tofixed2 | qfw}}
          <!-- {{item.id}} -->
          USD
        </span>
      </div>

      <div class="tac small mt-2">
        <a 
          :href="`${$store.state.sitecfg.url_network_address_view}${item.reward_address}`"
          class="u t-gray"
          >
          {{lg('',{
            en: 'View on HecoScan',
            zh: '在HecoScan查看',
          })}}
          <!-- {{item.reward_address | shortAddress}} -->
        </a>
      </div>

    </div>
    
  </div>
</template>

<script>
import bus from '@/bus.js'
import {mapActions} from 'vuex'

export default {
  name: 'poolCard',
  components: {},
  props: [
    'item',
    'cfg_view_staked',
  ],
  data() {
    return {
      num_staked: '-',
      num_reward: '-',

      // 
      num_staked_total: '-',
      
      num_lp_amount_total: 0,
    }
  },
  computed: {
    calc_apy(){
      let v = this
      let mark = '-'

      if(v.num_lp_amount_total && bus.lava_price){
        mark = v.item.daily_supply * bus.lava_price * 365 / v.num_lp_amount_total
      }
      return mark
    },
  },
  watch: {},
  methods: {
    ...mapActions([
      'getStakeTokenStaked',
      'getStakeRewardAvaiable',
      'getTotalStake',
      'getLPPoolTotalValue',

      'getHasStakeBalance',
      'pendingSushi'
    ]),

    async getStaked(){
      let v = this
      // 
      console.log(v.item)
      let address_my = v.$store.state.web3.account
      let mark =  await v.getHasStakeBalance({
        stakeTokenAddress:v.item.token_address,
        stakeRewardAddress: v.item.reward_address,
        num_id: v.item.num_id,
        address: address_my,
      })
      v.num_staked = mark
    },

    async getReward(){
      let v = this
      let address_my = v.$store.state.web3.account
      let mark =  await v.pendingSushi({
        stakeRewardAddress: v.item.reward_address,
        num_id: v.item.num_id,
        address: address_my,
      })
      // console.log('*********************')
      // console.log(mark)
      v.num_reward = mark
    },

    async getStakedTotal(){
      let v = this
      // 
      // let address_my = v.$store.state.web3.account

      // let mark =  await v.getTotalStake({
      //   id: v.item.id,
      //   stakeTokenAddress:v.item.token_address,
      //   stakeRewardAddress: v.item.reward_address,
      //   num_id: v.item.num_id,
      //   // address: address_my,
      // })

      let mark =  await v.getLPPoolTotalValue({
        token_address:v.item.token_address,
        num_id: v.item.num_id,
      })

      v.num_staked_total = mark
    },

    async getLpAmountTotal(){
      let v = this
      let num = await v.getLPPoolTotalValue({
        token_address: v.item.token_address
      })
      // console.log('getLpAmountTotal-----------',v.item.num_id)
      // console.log(num)
      v.num_lp_amount_total = num
    },

    run(){
      let v = this
      v.getStakedTotal()
      setTimeout(function(){
        v.getLpAmountTotal()
      },600)
      this.getStaked()
      this.getReward()
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .sp-item{
    width: 90%;
    margin: 0 auto;

    .sp-core{
      display: inline-block;
      border: 1px solid $c;
      color: $c;
      border-radius: 4px;
      padding: 0 5px;
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      height: 22px;
    }
  }
</style>